export const getUserRole = (user) => {
  if (!user) {
    return null;
  }

  return (
    user.app_metadata?.role ||
    user.role ||
    user.raw?.app_metadata?.role ||
    null
  );
};

export const isAdminUser = (user) => getUserRole(user) === 'admin';
